import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RegWallContainer } from '@surfline/quiver-react';
import { getShowForm } from '../../../../selectors/navigation';
import SignIn from '../SignIn';
import CreateAccount from '../CreateAccount';
import LearnMore from '../LearnMore';
import Home from '../Home';
import { showForm as navigate } from '../../../../actions/navigation';
import { CREATE_ACCOUNT, SIGN_IN, LEARN_MORE, HOME } from '../../../../common/constants';

/**
 * @function MeterBottomSheetRegWall
 * @param {object} props
 * @return {JSX.Elemet}
 */
const MeterBottomSheetRegWall = () => {
  const showForm = useSelector(getShowForm);
  const dispatch = useDispatch();
  const handleNavigation = (goto) => dispatch(navigate(goto));
  const renderForm = () => {
    switch (showForm) {
      case CREATE_ACCOUNT:
        return <CreateAccount />;
      case SIGN_IN:
        return <SignIn />;
      case LEARN_MORE:
        return <LearnMore />;
      default:
        return <Home />;
    }
  };

  return (
    <div className="sl-meter-bottom-sheet">
      <RegWallContainer>
        <div className="sl-meter-bottom-sheet__modal">
          {showForm === HOME ? null : (
            <button
              className="sl-meter-bottom-sheet__modal__action__back"
              onClick={() => handleNavigation(HOME)}
              type="button"
            >
              <div className="sl-meter-bottom-sheet__modal__action__arrow" />
              <span>BACK</span>
            </button>
          )}
          {renderForm()}
        </div>
      </RegWallContainer>
    </div>
  );
};

export default MeterBottomSheetRegWall;
